export function mapSubCategoriesToTreeNodes(catalogs: any[]): any[] {
  return (
    catalogs?.map((item) => ({
      key: item.id,
      label: item.name,
      data: {
        id: item.id,
        name: item.name,
        reference: item.reference,
        parent_id: item.parent_id,
        generated: item.generated,
      },
      selectable: true,
      children: mapSubCategoriesToTreeNodes(item.sub_catalogs || []),
    })) || []
  );
}

export function buildCategoryTree(flatList: any[]): any[] {
  const root: any[] = [];
  const lookup: Record<string, any> = {};

  flatList.forEach(({ reference, id }) => {
    let currentRef = '';
    let currentLevel = root;

    reference.split('>').forEach((name: string) => {
      currentRef = currentRef ? `${currentRef}>${name}` : name;

      if (!lookup[currentRef]) {
        lookup[currentRef] = {
          label: name,
          key: currentRef,
          data: { name, reference: currentRef, id: null },
          children: [],
        };
        currentLevel.push(lookup[currentRef]);
      }

      if (currentRef === reference) {
        lookup[currentRef].data.id = id;
      }

      currentLevel = lookup[currentRef].children;
    });
  });

  return root;
}

export function findNodeById(tree: any[], id: string): any | null {
  if (!Array.isArray(tree)) return null;

  for (const node of tree) {
    if (node.data?.id === id) return node;
    if (node.children?.length) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return null;
}

export function buildCategoryTreeFromSelected(selectedNodes: any[]): any[] {
  const tree: any[] = [];
  const lookup: Record<string, any> = {};

  selectedNodes.forEach((node) => {
    const parts = node.data.reference.split('>');
    let currentLevel = tree;
    let currentRef = '';

    parts.forEach((part: string) => {
      currentRef = currentRef ? `${currentRef}>${part}` : part;

      if (!lookup[currentRef]) {
        const newNode = {
          label: part,
          key: currentRef,
          children: [],
        };
        lookup[currentRef] = newNode;
        currentLevel.push(newNode);
      }

      currentLevel = lookup[currentRef].children;
    });
  });

  return tree;
}

export function flattenCategoryTree(tree: any[], level: number = 0): any[] {
  const result: any[] = [];
  tree.forEach((node) => {
    result.push({ label: node.label, level });
    if (node.children && node.children.length > 0) {
      result.push(...flattenCategoryTree(node.children, level + 1));
    }
  });
  return result;
}

export function collectAllSubIds(nodes: any[], idSet: Set<string>): void {
  for (const node of nodes) {
    if (node.sub_catalogs?.length) {
      for (const sub of node.sub_catalogs) {
        idSet.add(sub.id);
        collectAllSubIds([sub], idSet);
      }
    }
  }
}

export function mergeCategoryTrees(targetTree: any[], fullCategoryTree: any[]): void {
  for (const newNode of fullCategoryTree) {
    const existingNode = findNodeById(targetTree, newNode.data.id);

    if (!existingNode) {
      targetTree.push(newNode);
    } else {
      mergeCategoryTrees(existingNode.children, newNode.children || []);
    }
  }
}

export function insertNodeToTreeByReference(tree: any[], node: any) {
  const reference = node?.data?.reference;
  if (!reference) return;

  const pathParts = reference.split('>').map((part: string) => part.trim());
  let currentNodes = tree;
  let accumulatedPath = '';

  for (let depth = 0; depth < pathParts.length; depth++) {
    const currentPart = pathParts[depth];
    accumulatedPath = accumulatedPath ? `${accumulatedPath}>${currentPart}` : currentPart;

    let existingNode = currentNodes.find((n: any) => n.label === currentPart);

    if (!existingNode) {
      if (depth === pathParts.length - 1) {
        existingNode = node;
        currentNodes.push(existingNode);
      } else {
        return;
      }
    }

    existingNode.children = existingNode.children || [];
    currentNodes = existingNode.children;
  }
}


export function getLabelNode(node: any): string {
  let ref = node?.data?.reference;

  if (!ref) return node?.label;

  return ref;
}
